/**
 * form submit data
 */
const submit = document.querySelector('#gyeonppf');
const scriptURL = 'https://script.google.com/macros/s/AKfycbw1H2N0oSWoAAwx3uoaG-cQrh-Qzc4Y7Z8JrugW883JWBQhKfoxXfypVPgaxW_ikVf0mA/exec';
// const oldscriptURL = 'https://script.google.com/macros/s/AKfycbywoEO0xISc3-AFLju2xojuGOOlS0AMmP74NqTSaZM6A1RHI4zOCPbxteQZfl0EPAfx/exec'
// const scriptURLLocalhost = 'https://script.google.com/macros/s/AKfycbygozbWzQjwHlDZPK6auEeqDJDIdZS2ilH3jitGb5NEloHtyN21JAhchrVZu_Jlgdxb/exec'

/**
 * Plik: desktop-detection.js
 * Opis: Wykrywanie aplikacji desktopowej i zarządzanie reCAPTCHA
 */

// Funkcja do wielokryterialnego wykrywania aplikacji desktopowej
function detectDesktopApp() {
  // Wyniki detekcji z różnych metod
  const results = {
    url: false,
    iframe: false,
    userAgent: false,
    electronObjects: false,
    cefFramework: false,
    localStorage: false
  };

  try {
    // 1. Sprawdź parametr URL
    const urlParams = new URLSearchParams(window.location.search);
    results.url = urlParams.has('desktop_app') && urlParams.get('desktop_app') === 'true';

    // 2. Sprawdź czy strona jest w iframe
    results.iframe = (window.self !== window.top);

    // 3. Sprawdź user-agent
    const userAgent = navigator.userAgent.toLowerCase();
    results.userAgent = (
      userAgent.includes('electron') ||
      userAgent.includes('nwjs') ||
      userAgent.includes('phantomjs')
      // (userAgent.includes('chrome') && !userAgent.includes('chrome-extension'))
    );

    // 4. Sprawdź obecność obiektów charakterystycznych dla Electron
    results.electronObjects = (
      typeof window.process !== 'undefined' &&
      typeof window.process.versions !== 'undefined' &&
      typeof window.process.versions.electron !== 'undefined'
    );

    // 5. Sprawdź CEF Framework (Chromium Embedded Framework)
    results.cefFramework = (
      // Sprawdź czy chrome object ma cechy CEF
      (typeof window.chrome !== 'undefined' && window.chrome !== null) ||
      // Sprawdź brak pewnych obiektów typowych dla normalnej przeglądarki
      (typeof window.chrome !== 'undefined' && typeof window.chrome.webstore === 'undefined') ||
      // Sprawdź user agent dla CEF
      userAgent.includes('cef') ||
      // Sprawdź czy to iframe ale bez możliwości dostępu do parent (izolacja CEF)
      (function() {
        try {
          if (window.self !== window.top) {
            // Próbuj dostać się do parent - w CEF może być zablokowane
            return !window.parent || window.parent === window;
          }
          return false;
        } catch (e) {
          // Jeśli wystąpił błąd przy dostępie do parent, prawdopodobnie CEF
          return true;
        }
      })()
    );

    // 6. Sprawdź localStorage
    results.localStorage = localStorage.getItem('is_desktop_app') === 'true';
    
    // Logowanie wyników dla debugowania
    console.log("Desktop app detection results:", results);
    
    // Decyzja końcowa - wystarczy spełnienie jednego z kryteriów
    const isDesktopApp = Object.values(results).some(result => result === true);
    
    // Zapisz wynik do localStorage na przyszłość
    if (isDesktopApp) {
      try {
        localStorage.setItem('is_desktop_app', 'true');
      } catch (e) {
        console.warn("Could not save desktop app detection to localStorage:", e);
      }
    }
    
    return isDesktopApp;
  } catch (error) {
    console.error("Error during desktop app detection:", error);
    // W przypadku błędu, zachowujemy się bezpiecznie zakładając, że to nie jest aplikacja desktopowa
    return false;
  }
}

// Wykonaj detekcję na początku
const isDesktopApp = detectDesktopApp();
console.log("Running in desktop app:", isDesktopApp);

// Ustaw atrybuty dla stylizacji i późniejszego użycia
document.documentElement.setAttribute('data-desktop-app', isDesktopApp ? 'true' : 'false');
console.log(isDesktopApp)
// Ładuj skrypt reCAPTCHA tylko jeśli NIE jesteśmy w aplikacji desktopowej
if (!isDesktopApp) {
  // Opóźnione ładowanie reCAPTCHA dla lepszej wydajności
  window.addEventListener('DOMContentLoaded', function() {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.src = "https://www.google.com/recaptcha/api.js?render=6LdUVQcrAAAAAL2v-l-RL1a4av4TZ8bKy5sYu2i6";
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript);
    console.log("reCAPTCHA script loaded (browser mode)");
    
    // Oznacz, że reCAPTCHA się załadowało
    window.RECAPTCHA_READY = true;
  });
} else {
  console.log("Desktop app detected - reCAPTCHA disabled");
}

// Pomocnicza funkcja do weryfikacji reCAPTCHA przed wysłaniem formularza
// Można używać w obsłudze formularza
function verifyRecaptchaOrSubmit(callback) {
  const isDesktopApp = document.documentElement.getAttribute('data-desktop-app') === 'true';
  
  if (isDesktopApp) {
    // Pomiń weryfikację w aplikacji desktopowej
    console.log("Desktop app - skipping reCAPTCHA verification");
    callback('');
    return;
  }
  
  // Funkcja do sprawdzania, czy reCAPTCHA jest gotowa
  function checkRecaptchaAndExecute() {
    if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.ready === 'function') {
      try {
        grecaptcha.ready(function() {
          grecaptcha.execute('6LdUVQcrAAAAAL2v-l-RL1a4av4TZ8bKy5sYu2i6', {action: 'submit'})
          .then(function(token) {
            callback(token);
          })
          .catch(function(error) {
            console.error('reCAPTCHA error:', error);
            alert('Problem with reCAPTCHA. Please try again later.');
            callback('');
          });
        });
      } catch (error) {
        console.error('Failed to execute reCAPTCHA:', error);
        alert('Problem with reCAPTCHA. Please try again later.');
        callback('');
      }
    } else {
      console.warn("reCAPTCHA not available yet, checking again in 500ms");
      setTimeout(checkRecaptchaAndExecute, 500);
    }
  }
  
  // Jeśli reCAPTCHA jest gotowa, użyj jej, w przeciwnym razie poczekaj
  if (window.RECAPTCHA_READY) {
    checkRecaptchaAndExecute();
  } else {
    // Jeśli skrypt reCAPTCHA nie załadował się w rozsądnym czasie, pozwól wysłać formularz
    console.warn("reCAPTCHA script not loaded - proceeding without verification");
    callback('');
  }
}

// Dodanie obsługi recaptcha i ograniczeń czasowych
document.addEventListener('DOMContentLoaded', function() {
  // Ustaw timestamp kiedy formularz się załadował
  document.getElementById('timestamp').value = Date.now();

  // Sprawdź limity wysyłki formularzy
  checkSubmissionLimits();
});

// Funkcja sprawdzająca limity wysyłki formularzy (max 10 na godzinę)
function checkSubmissionLimits() {
  const submitButton = document.querySelector('#formSubmit');
  const ONE_HOUR = 60 * 60 * 1000; // 1 godzina w milisekundach
  
  // Pobierz historię wysyłek z localStorage
  let submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
  
  // Usuń wpisy starsze niż 1 godzina
  const currentTime = Date.now();
  submissions = submissions.filter(time => (currentTime - time) < ONE_HOUR);
  
  // Zapisz oczyszczoną historię
  localStorage.setItem('formSubmissions', JSON.stringify(submissions));
  
  // Sprawdź czy przekroczono limit 10 wysyłek na godzinę
  if (submissions.length >= 10) {
    // Oblicz najwcześniejszy czas, kiedy można będzie ponownie wysłać formularz
    const oldestSubmission = Math.min(...submissions);
    const timeToReset = ONE_HOUR - (currentTime - oldestSubmission);
    const minutesToWait = Math.ceil(timeToReset / 60000);
    
    submitButton.disabled = true;
    submitButton.value = `LIMIT (${minutesToWait} MIN)`;
    
    // Odblokuj przycisk po upływie czasu
    setTimeout(() => {
      checkSubmissionLimits(); // Sprawdź limity ponownie
    }, timeToReset);
  }
}


$(document).ready(function(){

  const isDesktopApp = document.documentElement.getAttribute('data-desktop-app') === 'true';
  console.log("Form init - Desktop app:", isDesktopApp);

  // Dodaj ukryte pole formularza z informacją o aplikacji desktopowej
  const desktopAppInput = document.createElement('input');
  desktopAppInput.type = 'hidden';
  desktopAppInput.name = 'is_desktop_app';
  desktopAppInput.value = isDesktopApp ? 'true' : 'false';
  document.getElementById('gyeonppf').appendChild(desktopAppInput);
  
  const selectArea = document.querySelector('#selectArea');

  selectArea.addEventListener('change', (e) => {
    let target  = e.target.options[e.target.selectedIndex].text
    if(target !== 'Other'){
      document.getElementById('otherInput').style.display = "none";
    } else {
      document.getElementById('otherInput').style.display = "block";
    };
  });


  const photoInputsContainer = document.getElementById('photoInputsContainer');
  const addPhotoButton = document.getElementById('addPhotoButton');
  const counterInfo = document.querySelector('.counter-info');
  const MAX_PHOTOS = 3;
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff'];
  
  let photoCount = 1; // Zaczynamy z jednym inputem
  
  // Dodanie metod walidacji dla zdjęć
  $.validator.addMethod("validImageType", function(value, element) {
    if (element.files && element.files[0]) {
      const file = element.files[0];
      return allowedTypes.includes(file.type);
    }
    return true; // Brak pliku to poprawna wartość
  }, "Not allowed file type. Allowed types: jpg, jpeg, png, gif, bmp, tiff.");
  
  $.validator.addMethod("validImageSize", function(value, element) {
    if (element.files && element.files[0]) {
      const file = element.files[0];
      return file.size <= 3 * 1024 * 1024; // 3MB w bajtach
    }
    return true; // Brak pliku to poprawna wartość
  }, "File is too large. Max size is 3MB.");
  
  // Inicjalizacja pierwszego inputa
  setupPhotoInput(1);
  updateButtonState();
  
  // Obsługa dodawania nowego inputa
  addPhotoButton.addEventListener('click', function() {
    // Inkrementacja licznika
    photoCount++;
    
    // Stworzenie nowego inputa
    const newId = photoCount;
    const newWrapper = document.createElement('div');
    newWrapper.className = 'photo-input-wrapper';
    newWrapper.id = `photoWrapper-${newId}`;
    newWrapper.dataset.id = newId;
    
    newWrapper.innerHTML = `
      <div class="content__input">
        <input type="file" id="photoInput-${newId}" name="PHOTO-${newId}" class="photo-input" accept="image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/tiff"/>
        <button type="button" class="clear-photo-button" id="clearPhoto-${newId}" style="display: none;">Clear</button>
      </div>
      <div class="preview-container">
        <img id="photoPreview-${newId}" src="#" class="file-preview" style="display: none;">
      </div>
    `;
    
    photoInputsContainer.appendChild(newWrapper);
    
    // Inicjalizacja nowego inputa
    setupPhotoInput(newId);
    
    // Dodaj nową regułę walidacji do nowego inputa
    addValidationRules(newId);
    
    // Aktualizacja stanu przycisku dodającego
    updateButtonState();
  });
  
  // Funkcja dodająca reguły walidacji do inputa ze zdjęciem
  function addValidationRules(id) {
    const selector = `#photoInput-${id}`;
    
    $(selector).rules("add", {
      validImageType: true,
      validImageSize: true
    });
  }
  
  // Funkcja do ustawienia obsługi inputa zdjęcia
  function setupPhotoInput(id) {
    const photoInput = document.getElementById(`photoInput-${id}`);
    const photoPreview = document.getElementById(`photoPreview-${id}`);
    const clearPhotoButton = document.getElementById(`clearPhoto-${id}`);
    
    // Obsługa zmiany pliku
    photoInput.addEventListener('change', function() {
      const file = this.files[0];
      
      if (file) {
        // Wczytanie podglądu
        const reader = new FileReader();
        reader.onload = function(e) {
          photoPreview.src = e.target.result;
          photoPreview.style.display = 'block';
        };
        reader.readAsDataURL(file);
        
        // Pokazanie przycisku usuwania
        clearPhotoButton.style.display = 'block';
        
        // Wyzwolenie walidacji jQuery
        $(photoInput).valid();
      } else {
        // Ukrycie przycisku i podglądu
        clearPhotoButton.style.display = 'none';
        photoPreview.src = '#';
        photoPreview.style.display = 'none';
      }
    });
    
    // Obsługa przycisku usuwania
    clearPhotoButton.addEventListener('click', function() {
      // Jeśli to pierwszy input, tylko czyścimy go
      if (id === 1) {
        photoInput.value = '';
        photoPreview.src = '#';
        photoPreview.style.display = 'none';
        this.style.display = 'none';
      } else {
        // Dla kolejnych inputów - usuwamy cały wrapper
        const wrapper = document.getElementById(`photoWrapper-${id}`);
        wrapper.remove();
        
        // Zmniejszamy licznik
        photoCount--;
      }
      
      // Aktualizacja stanu przycisku dodającego
      updateButtonState();
    });
  }
  
  // Funkcja aktualizująca stan przycisku dodającego
  function updateButtonState() {
    // Aktualizacja licznika
    counterInfo.textContent = `${photoCount}/3 photo`;
    
    // Wyłączenie przycisku, jeśli osiągnięto limit
    if (photoCount >= MAX_PHOTOS) {
      addPhotoButton.disabled = true;
    } else {
      addPhotoButton.disabled = false;
    }
  }

  // Funkcja do resetowania formularza i wszystkich inputów zdjęć
  function resetFormAndInputs() {
    // Resetuj cały formularz
    document.getElementById('gyeonppf').reset();
    
    // Znajdź wszystkie wrappery inputów zdjęć (oprócz pierwszego)
    const wrappers = document.querySelectorAll('.photo-input-wrapper:not(#photoWrapper-1)');
    
    // Usuń wszystkie wrappery oprócz pierwszego
    wrappers.forEach(wrapper => {
      wrapper.remove();
    });
    
    // Wyczyść pierwszy input
    const firstPhotoInput = document.getElementById('photoInput-1');
    const firstPhotoPreview = document.getElementById('photoPreview-1');
    const firstClearButton = document.getElementById('clearPhoto-1');
    
    if (firstPhotoInput) firstPhotoInput.value = '';
    if (firstPhotoPreview) {
      firstPhotoPreview.src = '#';
      firstPhotoPreview.style.display = 'none';
    }
    if (firstClearButton) firstClearButton.style.display = 'none';
    
    // Zresetuj licznik do 1
    photoCount = 1;
    
    // Zaktualizuj licznik i stan przycisku
    updateButtonState();
    
    console.log('Form send successfully and reset!');
  }

  // Konfiguracja walidatora formularza
  $('#gyeonppf').validate({
    rules: {
      BRAND: "required",
      MODEL: "required",
      SUBMODEL: "required",
      TRIM: "required",
      YEAR: "required",
      AREA: "required",
      ACCOUNT: "required",
      "PHOTO-1": {
        validImageType: true,
        validImageSize: true
      }
    },
    messages: {
      BRAND: "This field is required.",
      MODEL: "This field is required.",
      SUBMODEL: "This field is required.",
      TRIM: "This field is required.",
      YEAR: "This field is required.",
      AREA: "This field is required.",
      ACCOUNT: "This field is required."
    },
    errorPlacement: function(error, element) {
      // Customize error placement. Put errors after the file input
      if (element.hasClass('photo-input')) {
        error.insertAfter(element.closest(".content__input"));
      } else {
        error.insertAfter(element);
      }
    },
    submitHandler: function(form) {
      const submitButton = document.querySelector('#formSubmit');
      submitButton.disabled = true;
      
      // Funkcja do wysyłania formularza po (opcjonalnej) weryfikacji reCAPTCHA
      function submitFormWithToken(token) {
        if (token) {
          // Jeśli mamy token reCAPTCHA, dodajemy go do formularza
          if (document.getElementById('g-recaptcha-response')) {
            document.getElementById('g-recaptcha-response').value = token;
          } else {
            // Jeśli nie ma elementu, utwórz go
            const recaptchaInput = document.createElement('input');
            recaptchaInput.type = 'hidden';
            recaptchaInput.id = 'g-recaptcha-response';
            recaptchaInput.name = 'g-recaptcha-response';
            recaptchaInput.value = token;
            form.appendChild(recaptchaInput);
          }
        }
        
        const requestBody = new FormData(form);

        // Modify the "AREA" field based on the selection
        const areaSelect = document.querySelector('[name="AREA"]');
        const otherAreaInput = document.querySelector('[name="OTHERAREA"]');

        if (areaSelect.value === 'other') {
          const areaValue = otherAreaInput.value;
          requestBody.set('AREA', 'Other: ' + areaValue);
          requestBody.delete('OTHERAREA');
        } else {
          requestBody.set('AREA', areaSelect.value);
          if (requestBody.has('OTHERAREA')) {
            requestBody.delete('OTHERAREA');
          }
        }

        $.ajax({
          url: "form.php",
          type: "POST",
          data: requestBody,
          processData: false,
          contentType: false,
          success: function(data){
            console.log('Received data:', data);
            
            if (data.status === 'success') {
              // Łączenie wszystkich URL-i zdjęć w jedno pole (rozdzielone przecinkami)
              // Wartość może zawierać jeden URL lub wiele URL-i
              const photoUrls = data.file_urls || [];
              
              if (photoUrls.length > 0) {
                // Połącz URL-e zdjęć do jednego pola rozdzielone przecinkiem
                requestBody.set('PHOTO', photoUrls.join(','));
              }
              
              // Usuń pojedyncze pola ze zdjęciami z formularza wysyłanego do Google Sheets
              for (let i = 1; i <= MAX_PHOTOS; i++) {
                requestBody.delete(`PHOTO-${i}`);
              }
              
              // Wyślij dane do Google Sheets
              fetch(scriptURL, { 
                method: 'POST', 
                body: requestBody})
                .then(response => {
                  console.log('Google Sheets response:', response);
                  submitButton.disabled = false;
                  $('#messageSuccess').fadeIn().delay(3000).fadeOut(0);
                  
                  // Resetuj formularz i wszystkie inputy
                  resetFormAndInputs();
                  
                  // Zapisz historię wysyłek formularzy
                  let submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
                  submissions.push(Date.now());
                  localStorage.setItem('formSubmissions', JSON.stringify(submissions));
                  
                  // Sprawdź limity po wysłaniu
                  checkSubmissionLimits();
                })
                .catch(error => {
                  console.error('Error connect to Google sheet:', error);
                  alert('Error! ' + error.message);
                  submitButton.disabled = false;
                });
            } else {
              alert("File upload failed: " + (data.message || 'Unknown error'));
              submitButton.disabled = false;
            }
          },
          error: function(xhr, status, error){
            console.error('Error AJAX:', status, error);
            console.log('Server response:', xhr.responseText);
            $('#messageError').fadeIn().delay(3000).fadeOut(0);
            submitButton.disabled = false;
          }
        });
      }
      
      // Użyj funkcji pomocniczej z desktop-detection.js do zarządzania reCAPTCHA
      verifyRecaptchaOrSubmit(submitFormWithToken);

      return false; // Prevent the default form submission
    }
  });
});

/**
 * Handle external links in desktop app mode
 * Open links in system browser instead of iframe
 */
document.addEventListener('DOMContentLoaded', function() {
  const isDesktopApp = document.documentElement.getAttribute('data-desktop-app') === 'true';

  if (isDesktopApp) {
    // Find all external links (links to gyeon.co or other external domains)
    const externalLinks = document.querySelectorAll('a[href^="http"]');

    externalLinks.forEach(link => {
      // Add target="_blank" to open in new window/tab
      // In Electron, this will trigger 'new-window' event that can be handled to open in system browser
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      console.log('External link prepared for desktop app:', link.href);
    });
  }
});